import { Check, Plus, Trash2, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PASSES, money } from "@/lib/daytime";

function PassCard({ p, selected, onPick }) {
  return (
    <button onClick={() => onPick(p.key)} data-testid={`pick-pass-${p.key}`}
      className={`relative text-left rounded-3xl bg-white p-5 border-2 transition-transform duration-200 hover:-translate-y-1 ${p.popular ? "sm:scale-[1.04] shadow-xl" : ""} ${selected ? "border-navy ring-4 ring-turquoise/40" : "border-slate-100"}`}
      style={{ borderTopColor: p.color, borderTopWidth: 8 }}>
      {p.popular && <span className="absolute -top-3 right-4 bg-coral text-white text-[11px] font-black tracking-wider rounded-full px-3 py-1 flex items-center gap-1"><Star className="w-3 h-3 fill-white" /> MOST POPULAR</span>}
      <p className="font-display font-black text-navy">{p.title}</p>
      <p className="font-display font-black text-5xl mt-1" style={{ color: p.color }}>{money(p.price)}</p>
      <p className="font-bold text-navy text-sm">{p.time}</p>
      <ul className="mt-3 space-y-1 text-sm text-slate-600">{p.best.map((b) => <li key={b} className="flex gap-1.5"><Check className="w-4 h-4 text-turquoise shrink-0 mt-0.5" />{b}</li>)}</ul>
      <p className="text-xs text-slate-400 mt-2">{p.note}</p>
      <span className={`mt-4 flex items-center justify-center rounded-full h-12 font-black text-sm ${selected ? "bg-navy text-white" : "bg-gold text-navy"}`}>{selected ? "SELECTED ✓" : p.cta}</span>
    </button>
  );
}

export function PassStep({ prices, settings, main, setMain, sibs, setSibs, onNext }) {
  const passes = PASSES(prices, settings);
  const sibOf = (k) => passes.find((p) => p.key === k);
  return (
    <div className="space-y-6" data-testid="step-pass">
      <div className="grid sm:grid-cols-3 gap-5 pt-3">{passes.map((p) => <PassCard key={p.key} p={p} selected={main === p.key} onPick={setMain} />)}</div>
      {main && (
        <div className="bg-white rounded-3xl border border-slate-200 p-5" data-testid="sibling-section">
          <p className="font-display font-black text-navy text-lg">Bringing Another Explorer?</p>
          <p className="text-sm text-slate-500">Brothers & sisters from the same household get sibling pricing.</p>
          <div className="space-y-2 mt-3">
            {sibs.map((s, i) => (
              <div key={i} className="flex items-center gap-2" data-testid={`sibling-row-${i}`}>
                <select value={s} onChange={(e) => setSibs(sibs.map((x, j) => (j === i ? e.target.value : x)))} className="flex-1 h-12 rounded-xl border border-slate-200 px-3 bg-white text-sm font-semibold" data-testid={`sibling-pass-${i}`}>
                  {passes.map((p) => <option key={p.key} value={p.key}>{p.key === "pass2" ? "2-Hour" : p.key === "pass4" ? "4-Hour Adventure" : "All-Day"} Sibling Pass — {money(p.sibPrice)}</option>)}
                </select>
                <Button variant="ghost" onClick={() => setSibs(sibs.filter((_, j) => j !== i))} className="h-12 text-coral" data-testid={`sibling-remove-${i}`}><Trash2 className="w-4 h-4" /></Button>
              </div>
            ))}
          </div>
          <Button variant="outline" onClick={() => setSibs([...sibs, main])} className="mt-3 rounded-full h-11 border-turquoise text-navy font-bold" data-testid="add-sibling"><Plus className="w-4 h-4 mr-1" /> Add a sibling ({money(sibOf(main)?.sibPrice)})</Button>
        </div>
      )}
      <Button disabled={!main} onClick={onNext} className="w-full h-14 rounded-full bg-navy text-white font-black text-base" data-testid="step-pass-next">NEXT: CHOOSE YOUR DAY</Button>
    </div>
  );
}
